import { useRootStore } from 'stores/RootStore'
import { MobileWizardsDrawer } from 'components/Wizards/MobileWizards/MobileWizardsDrawer/MobileWizardsDrawer'
import { Button } from 'blaze-ui/Button'
import { WizardType } from 'components/Wizards/schemas/Types'
import { Caption } from 'blaze-ui/icons'

interface Props {
  altWizard: WizardType
}

export const AlternativeWizardButton = ({ altWizard }: Props) => {
  const { openDrawer, closeDrawer } = useRootStore().drawersStore

  const openAltWizard = () => {
    closeDrawer()
    openDrawer(MobileWizardsDrawer, { channel: altWizard, initialValues: {} })
  }

  return (
    <Button size="lg" variant="tertiary" frontIcon={Caption} fullWidth onPress={openAltWizard}>
      I just need a text post
    </Button>
  )
}
